import { render, staticRenderFns } from "./policyHandel.vue?vue&type=template&id=05f9111f&scoped=true"
import script from "./policyHandel.vue?vue&type=script&lang=js"
export * from "./policyHandel.vue?vue&type=script&lang=js"
import style0 from "./policyHandel.vue?vue&type=style&index=0&id=05f9111f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9111f",
  null
  
)

export default component.exports